<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="districts"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="区域编号">
            <el-input v-model.trim="filter.districtNO" placeholder="请输入区域编号" clearable/>
          </el-form-item>
          <el-form-item label="区域名称">
            <el-input v-model.trim="filter.districtName" placeholder="请输入区域名称" clearable/>
          </el-form-item>
          <el-form-item label="上级区域">
            <el-input v-model.trim="filter.parentName" placeholder="请输入上级区域名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <district-edit ref="districtEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import DistrictEdit from "./DistrictEdit";
  export default {
    components: { viewTable, DistrictEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(158),
          editAuth: this.$auth(159),
          delAuth: this.$auth(160),
        },
        filter: {
          districtNO: "",
          districtName: "",
          parentName: "",
        },
        columnsProperty: [
          {
            key: "districtNO",
            width: 100,
            align: "center",
          },
          {
            key: "districtName",
            minWidth: 150,
          },
          {
            key: "parentName",
            minWidth: 150,
          },
          {
            key: "note",
            minWidth: 150,
            tooltip: true,
            ellipsis: true,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.districtEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "districts", row.districtID).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
